define("shared/components/shared/credentials/status", ["exports", "@ember/component", "@ember/template-factory", "@ember/service", "@glimmer/component", "ember-concurrency"], function (_exports, _component, _templateFactory, _service, _component2, _emberConcurrency) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"ember-concurrency"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal @closable={{true}} @close={{action @close}} {{did-insert @resetState}} as |modal|>
    <modal.card @closeIcon={{true}} @portrait={{true}}>
      <modal.card-header>
        <h2 class="o--modalHeader__title">{{html-safe (t this.headingText)}}</h2>
        <p class="u--p__t__xs">
          {{html-safe (t this.subText nickname=this.socialProfile.nickname)}}
        </p>
      </modal.card-header>
      <modal.card-body class="u--p__t__0">
        {{! Status Card }}
        <div class="tAC--status {{this.cardStatus}}">
          {{! Status Info }}
          <div class="u--row u--row--noCollapse">
            {{! User Avatar }}
            <div class="u--col__8">
              <div class="o--user">
                <img class="o--user__avatar" src={{this.socialProfile.secureAvatarUrl}} />
                <span class="o--user__avatarChild--ig"><i class="i--ig--w"></i></span>
                {{#if this.isDisconnected}}
                  <span class="o--user__title u--text--hair u--text--danger">{{this.socialProfile.nickname}}</span>
                  <span class="o--user__desc u--text--danger">{{this.socialProfile.displayName}}</span>
                {{else if this.isExpiring}}
                  <span class="o--user__title u--text--hair u--text--warning">{{this.socialProfile.nickname}}</span>
                  <span class="o--user__desc u--text--warning">{{this.socialProfile.displayName}}</span>
                {{else}}
                  <span class="o--user__title u--text--hair u--text--success">{{this.socialProfile.nickname}}</span>
                  <span class="o--user__desc u--text--success">{{this.socialProfile.displayName}}</span>
                {{/if}}
              </div>
            </div>
            {{! Status }}
            <div class="u--col__4 u--p__t__xs">
              {{#if this.hasUnconnectedProfessional}}
                <div class="o--badge--sm o--badge--danger u--m__r__0 u--float--right">
                  {{t "credentials.status.unconnected"}}
                  {{svg-jar "warning" class="o--icon--sm u--m__l__xs"}}
                </div>
              {{else if this.isDisconnected}}
                <div class="o--badge--sm o--badge--danger u--m__r__0 u--float--right">
                  {{t "credentials.status.expired"}}
                  {{svg-jar "warning" class="o--icon--sm u--m__l__xs"}}
                </div>
              {{else if this.isExpiring}}
                <div class="o--badge--sm o--badge--warning u--m__r__0 u--float--right">
                  {{t "credentials.status.expiring"}}
                  {{svg-jar "warning" class="o--icon--sm u--m__l__xs"}}
                </div>
              {{else}}
                <div class="o--badge--sm o--badge--success u--m__r__0 u--float--right">
                  {{t "credentials.status.connected"}}
                  {{svg-jar "verified" class="o--icon--sm u--m__l__xs"}}
                </div>
              {{/if}}
            </div>
          </div>
          {{! Status CTA }}
          {{#unless @completed}}
            <div class="tAC--status__action">
              {{#if this.hasUnconnectedProfessional}}
                <p class="u--m__b__0 u--p__b__xs">
                  {{#if (or this.isCreator this.isInfluencer)}}
                    {{html-safe (t "credentials.cta.creator_upgrade" nickname=this.socialProfile.nickname)}}
                  {{else}}
                    {{html-safe (t "credentials.cta.business_upgrade" nickname=this.socialProfile.nickname)}}
                  {{/if}}
                </p>
              {{else if this.isDisconnected}}
                <p class="u--m__b__0 u--p__b__xs">{{html-safe (t "credentials.cta.refresh_connection")}}</p>
              {{else}}
                <p class="u--text--bold">{{t "credentials.cta.refresh_connection"}}</p>
              {{/if}}
            </div>
          {{/unless}}
        </div>
        {{! Status List }}
        {{#unless this.hasUnconnectedProfessional}}
          <div class="o--card u--m__t__md">
            <div class="o--cardBody u--p__lr">
              <p class="u--text--bold">{{t "credentials.feature_status.title"}}</p>
              <ul class="u--listUnstyle u--row">
                {{#unless this.isCreator}}
                  <li class="u--col__6">
                    <i class={{this.featureStatusCss}}></i>{{t "credentials.feature_status.auto_publish"}}
                  </li>
                {{/unless}}
                <li class="u--col__6">
                  <i class={{this.featureStatusCss}}></i>{{t "shared_words.analytics"}}
                </li>
                <li class="u--col__6">
                  <i class={{this.featureStatusCss}}></i>{{t "credentials.feature_status.instagram_planner"}}
                </li>
                <li class="u--col__6">
                  <i class={{this.featureStatusCss}}></i>{{t "credentials.feature_status.follower_count"}}
                </li>
                <li class="u--col__6">
                  <i class={{this.featureStatusCss}}></i>{{t "credentials.feature_status.conversations"}}
                </li>
                <li class="u--col__6">
                  <i class={{this.featureStatusCss}}></i>{{t "credentials.feature_status.post_performance"}}
                </li>
                <li class="u--col__6">
                  <i class={{this.featureStatusCss}}></i>{{t "credentials.feature_status.collect_media"}}
                </li>
                <li class="u--col__6">
                  <i class={{this.featureStatusCss}}></i>{{t "shared_words.linkinbio"}}
                </li>
                {{#if this.instagramBusiness.isConnectingTagProducts}}
                  <li class="u--col__6">
                    <i class={{this.tagProductsStatusCss}}></i>{{t "credentials.feature_status.tag_products"}}
                  </li>
                {{/if}}
              </ul>
            </div>
          </div>
        {{/unless}}
        {{#if this.isCreator}}
          <div class="o--card u--m__t__md">
            <div class="o--cardBody u--p__lr">
              <p class="u--text--bold">{{t "credentials.feature_status.not_supported_title"}}</p>
              <ul class="u--listUnstyle u--row">
                <li class="u--col__6">
                  {{svg-jar "warning" class="o--icon o--icon--danger u--m__r__xs"}}{{t
                    "credentials.feature_status.auto_publish_stories"
                  }}
                </li>
              </ul>
            </div>
          </div>
        {{/if}}
      </modal.card-body>
      <modal.card-footer>
        {{#if @completed}}
          <Shared::Ui::Button
            @additional="block"
            @onClick={{action @close}}
            @text={{t "shared_words.done"}}
            @variant="primary"
          />
        {{else}}
          <Shared::Ui::Button
            @additional="block"
            @promise={{task this.getConnectedPages}}
            @runningText={{t "shared_phrases.please_wait"}}
            @text={{t "shared_words.next"}}
            @variant="primary"
          />
        {{/if}}
      </modal.card-footer>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "M4pNKYj+",
    "block": "[[[8,[39,0],[[4,[38,2],[[30,2]],null]],[[\"@closable\",\"@close\"],[true,[28,[37,1],[[30,0],[30,1]],null]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,3,[\"card\"]],null,[[\"@closeIcon\",\"@portrait\"],[true,true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,3,[\"card-header\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,\"h2\"],[14,0,\"o--modalHeader__title\"],[12],[1,[28,[35,3],[[28,[37,4],[[30,0,[\"headingText\"]]],null]],null]],[13],[1,\"\\n      \"],[10,2],[14,0,\"u--p__t__xs\"],[12],[1,\"\\n        \"],[1,[28,[35,3],[[28,[37,4],[[30,0,[\"subText\"]]],[[\"nickname\"],[[30,0,[\"socialProfile\",\"nickname\"]]]]]],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,3,[\"card-body\"]],[[24,0,\"u--p__t__0\"]],null,[[\"default\"],[[[[1,\"\\n\"],[1,\"      \"],[10,0],[15,0,[29,[\"tAC--status \",[30,0,[\"cardStatus\"]]]]],[12],[1,\"\\n\"],[1,\"        \"],[10,0],[14,0,\"u--row u--row--noCollapse\"],[12],[1,\"\\n\"],[1,\"          \"],[10,0],[14,0,\"u--col__8\"],[12],[1,\"\\n            \"],[10,0],[14,0,\"o--user\"],[12],[1,\"\\n              \"],[10,\"img\"],[14,0,\"o--user__avatar\"],[15,\"src\",[30,0,[\"socialProfile\",\"secureAvatarUrl\"]]],[12],[13],[1,\"\\n              \"],[10,1],[14,0,\"o--user__avatarChild--ig\"],[12],[10,\"i\"],[14,0,\"i--ig--w\"],[12],[13],[13],[1,\"\\n\"],[41,[30,0,[\"isDisconnected\"]],[[[1,\"                \"],[10,1],[14,0,\"o--user__title u--text--hair u--text--danger\"],[12],[1,[30,0,[\"socialProfile\",\"nickname\"]]],[13],[1,\"\\n                \"],[10,1],[14,0,\"o--user__desc u--text--danger\"],[12],[1,[30,0,[\"socialProfile\",\"displayName\"]]],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"isExpiring\"]],[[[1,\"                \"],[10,1],[14,0,\"o--user__title u--text--hair u--text--warning\"],[12],[1,[30,0,[\"socialProfile\",\"nickname\"]]],[13],[1,\"\\n                \"],[10,1],[14,0,\"o--user__desc u--text--warning\"],[12],[1,[30,0,[\"socialProfile\",\"displayName\"]]],[13],[1,\"\\n\"]],[]],[[[1,\"                \"],[10,1],[14,0,\"o--user__title u--text--hair u--text--success\"],[12],[1,[30,0,[\"socialProfile\",\"nickname\"]]],[13],[1,\"\\n                \"],[10,1],[14,0,\"o--user__desc u--text--success\"],[12],[1,[30,0,[\"socialProfile\",\"displayName\"]]],[13],[1,\"\\n              \"]],[]]]],[]]],[1,\"            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"],[1,\"          \"],[10,0],[14,0,\"u--col__4 u--p__t__xs\"],[12],[1,\"\\n\"],[41,[30,0,[\"hasUnconnectedProfessional\"]],[[[1,\"              \"],[10,0],[14,0,\"o--badge--sm o--badge--danger u--m__r__0 u--float--right\"],[12],[1,\"\\n                \"],[1,[28,[35,4],[\"credentials.status.unconnected\"],null]],[1,\"\\n                \"],[1,[28,[35,6],[\"warning\"],[[\"class\"],[\"o--icon--sm u--m__l__xs\"]]]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"isDisconnected\"]],[[[1,\"              \"],[10,0],[14,0,\"o--badge--sm o--badge--danger u--m__r__0 u--float--right\"],[12],[1,\"\\n                \"],[1,[28,[35,4],[\"credentials.status.expired\"],null]],[1,\"\\n                \"],[1,[28,[35,6],[\"warning\"],[[\"class\"],[\"o--icon--sm u--m__l__xs\"]]]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"isExpiring\"]],[[[1,\"              \"],[10,0],[14,0,\"o--badge--sm o--badge--warning u--m__r__0 u--float--right\"],[12],[1,\"\\n                \"],[1,[28,[35,4],[\"credentials.status.expiring\"],null]],[1,\"\\n                \"],[1,[28,[35,6],[\"warning\"],[[\"class\"],[\"o--icon--sm u--m__l__xs\"]]]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],[[[1,\"              \"],[10,0],[14,0,\"o--badge--sm o--badge--success u--m__r__0 u--float--right\"],[12],[1,\"\\n                \"],[1,[28,[35,4],[\"credentials.status.connected\"],null]],[1,\"\\n                \"],[1,[28,[35,6],[\"verified\"],[[\"class\"],[\"o--icon--sm u--m__l__xs\"]]]],[1,\"\\n              \"],[13],[1,\"\\n            \"]],[]]]],[]]]],[]]],[1,\"          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"],[41,[51,[30,4]],[[[1,\"          \"],[10,0],[14,0,\"tAC--status__action\"],[12],[1,\"\\n\"],[41,[30,0,[\"hasUnconnectedProfessional\"]],[[[1,\"              \"],[10,2],[14,0,\"u--m__b__0 u--p__b__xs\"],[12],[1,\"\\n\"],[41,[28,[37,8],[[30,0,[\"isCreator\"]],[30,0,[\"isInfluencer\"]]],null],[[[1,\"                  \"],[1,[28,[35,3],[[28,[37,4],[\"credentials.cta.creator_upgrade\"],[[\"nickname\"],[[30,0,[\"socialProfile\",\"nickname\"]]]]]],null]],[1,\"\\n\"]],[]],[[[1,\"                  \"],[1,[28,[35,3],[[28,[37,4],[\"credentials.cta.business_upgrade\"],[[\"nickname\"],[[30,0,[\"socialProfile\",\"nickname\"]]]]]],null]],[1,\"\\n\"]],[]]],[1,\"              \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"isDisconnected\"]],[[[1,\"              \"],[10,2],[14,0,\"u--m__b__0 u--p__b__xs\"],[12],[1,[28,[35,3],[[28,[37,4],[\"credentials.cta.refresh_connection\"],null]],null]],[13],[1,\"\\n\"]],[]],[[[1,\"              \"],[10,2],[14,0,\"u--text--bold\"],[12],[1,[28,[35,4],[\"credentials.cta.refresh_connection\"],null]],[13],[1,\"\\n            \"]],[]]]],[]]],[1,\"          \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n\"],[41,[51,[30,0,[\"hasUnconnectedProfessional\"]]],[[[1,\"        \"],[10,0],[14,0,\"o--card u--m__t__md\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"o--cardBody u--p__lr\"],[12],[1,\"\\n            \"],[10,2],[14,0,\"u--text--bold\"],[12],[1,[28,[35,4],[\"credentials.feature_status.title\"],null]],[13],[1,\"\\n            \"],[10,\"ul\"],[14,0,\"u--listUnstyle u--row\"],[12],[1,\"\\n\"],[41,[51,[30,0,[\"isCreator\"]]],[[[1,\"                \"],[10,\"li\"],[14,0,\"u--col__6\"],[12],[1,\"\\n                  \"],[10,\"i\"],[15,0,[30,0,[\"featureStatusCss\"]]],[12],[13],[1,[28,[35,4],[\"credentials.feature_status.auto_publish\"],null]],[1,\"\\n                \"],[13],[1,\"\\n\"]],[]],null],[1,\"              \"],[10,\"li\"],[14,0,\"u--col__6\"],[12],[1,\"\\n                \"],[10,\"i\"],[15,0,[30,0,[\"featureStatusCss\"]]],[12],[13],[1,[28,[35,4],[\"shared_words.analytics\"],null]],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,\"li\"],[14,0,\"u--col__6\"],[12],[1,\"\\n                \"],[10,\"i\"],[15,0,[30,0,[\"featureStatusCss\"]]],[12],[13],[1,[28,[35,4],[\"credentials.feature_status.instagram_planner\"],null]],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,\"li\"],[14,0,\"u--col__6\"],[12],[1,\"\\n                \"],[10,\"i\"],[15,0,[30,0,[\"featureStatusCss\"]]],[12],[13],[1,[28,[35,4],[\"credentials.feature_status.follower_count\"],null]],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,\"li\"],[14,0,\"u--col__6\"],[12],[1,\"\\n                \"],[10,\"i\"],[15,0,[30,0,[\"featureStatusCss\"]]],[12],[13],[1,[28,[35,4],[\"credentials.feature_status.conversations\"],null]],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,\"li\"],[14,0,\"u--col__6\"],[12],[1,\"\\n                \"],[10,\"i\"],[15,0,[30,0,[\"featureStatusCss\"]]],[12],[13],[1,[28,[35,4],[\"credentials.feature_status.post_performance\"],null]],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,\"li\"],[14,0,\"u--col__6\"],[12],[1,\"\\n                \"],[10,\"i\"],[15,0,[30,0,[\"featureStatusCss\"]]],[12],[13],[1,[28,[35,4],[\"credentials.feature_status.collect_media\"],null]],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,\"li\"],[14,0,\"u--col__6\"],[12],[1,\"\\n                \"],[10,\"i\"],[15,0,[30,0,[\"featureStatusCss\"]]],[12],[13],[1,[28,[35,4],[\"shared_words.linkinbio\"],null]],[1,\"\\n              \"],[13],[1,\"\\n\"],[41,[30,0,[\"instagramBusiness\",\"isConnectingTagProducts\"]],[[[1,\"                \"],[10,\"li\"],[14,0,\"u--col__6\"],[12],[1,\"\\n                  \"],[10,\"i\"],[15,0,[30,0,[\"tagProductsStatusCss\"]]],[12],[13],[1,[28,[35,4],[\"credentials.feature_status.tag_products\"],null]],[1,\"\\n                \"],[13],[1,\"\\n\"]],[]],null],[1,\"            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"isCreator\"]],[[[1,\"        \"],[10,0],[14,0,\"o--card u--m__t__md\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"o--cardBody u--p__lr\"],[12],[1,\"\\n            \"],[10,2],[14,0,\"u--text--bold\"],[12],[1,[28,[35,4],[\"credentials.feature_status.not_supported_title\"],null]],[13],[1,\"\\n            \"],[10,\"ul\"],[14,0,\"u--listUnstyle u--row\"],[12],[1,\"\\n              \"],[10,\"li\"],[14,0,\"u--col__6\"],[12],[1,\"\\n                \"],[1,[28,[35,6],[\"warning\"],[[\"class\"],[\"o--icon o--icon--danger u--m__r__xs\"]]]],[1,[28,[35,4],[\"credentials.feature_status.auto_publish_stories\"],null]],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"]],[]]]]],[1,\"\\n    \"],[8,[30,3,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n\"],[41,[30,4],[[[1,\"        \"],[8,[39,9],null,[[\"@additional\",\"@onClick\",\"@text\",\"@variant\"],[\"block\",[28,[37,1],[[30,0],[30,1]],null],[28,[37,4],[\"shared_words.done\"],null],\"primary\"]],null],[1,\"\\n\"]],[]],[[[1,\"        \"],[8,[39,9],null,[[\"@additional\",\"@promise\",\"@runningText\",\"@text\",\"@variant\"],[\"block\",[28,[37,10],[[30,0,[\"getConnectedPages\"]]],null],[28,[37,4],[\"shared_phrases.please_wait\"],null],[28,[37,4],[\"shared_words.next\"],null],\"primary\"]],null],[1,\"\\n\"]],[]]],[1,\"    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[3]]]]]],[\"@close\",\"@resetState\",\"modal\",\"@completed\"],false,[\"shared/modal\",\"action\",\"did-insert\",\"html-safe\",\"t\",\"if\",\"svg-jar\",\"unless\",\"or\",\"shared/ui/button\",\"task\"]]",
    "moduleName": "shared/components/shared/credentials/status.hbs",
    "isStrictMode": false
  });

  let StatusComponent = (_dec = (0, _service.inject)('social/facebook-graph'), _dec2 = (0, _service.inject)('social/facebook-auth'), _dec3 = (0, _service.inject)('social/instagram-business'), (_class = class StatusComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "credentials", _descriptor2, this);

      _initializerDefineProperty(this, "errors", _descriptor3, this);

      _initializerDefineProperty(this, "facebook", _descriptor4, this);

      _initializerDefineProperty(this, "facebookAuth", _descriptor5, this);

      _initializerDefineProperty(this, "instagramBusiness", _descriptor6, this);

      _initializerDefineProperty(this, "intl", _descriptor7, this);

      _initializerDefineProperty(this, "segment", _descriptor8, this);
    }

    get socialProfile() {
      return this.credentials.socialProfile;
    }

    get state() {
      return this.credentials.state;
    }

    get owner() {
      return this.auth.currentAccount.owner;
    }

    get connectedPageId() {
      return this.socialProfile.facebookPageId;
    }

    get isDisconnected() {
      return this.socialProfile.hasUnconnectedProfessional || this.socialProfile.needsProfessionalTokenRefresh;
    }

    get hasUnconnectedProfessional() {
      return this.socialProfile.hasUnconnectedProfessional && !this.args.revokePermissions.isRunning;
    }

    get isExpiring() {
      return this.socialProfile.instagramBusinessTokenExpiring;
    }

    get needsRefresh() {
      return this.socialProfile.needsRefresh;
    }

    get socialProfileState() {
      return this.socialProfile.socialProfileState;
    }

    get isCreator() {
      return this.socialProfile.isCreator;
    }

    get isInfluencer() {
      return this.socialProfile.businessModel === 'blog_influencer' && this.args.source === 'partnerships';
    }

    get featureStatusCss() {
      if (this.isDisconnected) {
        return 'u--m__r__xs i-warning u--text--danger';
      } else if (this.isExpiring) {
        return 'u--m__r__xs i-danger-1 u--text--warning';
      }

      return 'u--m__r__xs i-verified u--text--success';
    }

    get tagProductsStatusCss() {
      if (this.isDisconnected || !this.instagramBusiness.hasRequiredInstagramAdditionalScopes(this.socialProfile)) {
        return 'u--m__r__xs i-warning u--text--danger';
      } else if (this.isExpiring) {
        return 'u--m__r__xs i-danger-1 u--text--warning';
      }

      return 'u--m__r__xs i-verified u--text--success';
    }

    get cardStatus() {
      if (this.isDisconnected) {
        return 'tAC--status--danger';
      } else if (this.isExpiring) {
        return 'tAC--status--warning';
      }

      return 'tAC--status--success';
    }

    get headingText() {
      if (this.args.completed) {
        if (this.isCreator) {
          return this.state.isConnecting ? 'credentials.header.connect_title_creator' : 'credentials.header.success_title';
        }

        return this.state.isConnecting ? 'credentials.header.connect_title' : 'credentials.header.success_title';
      } else if (this.hasUnconnectedProfessional) {
        if (this.isCreator) {
          return 'credentials.header.unconnected_title_creator';
        } else if (this.isInfluencer) {
          return 'credentials.header.unconnected_title_influencer';
        }

        return 'credentials.header.unconnected_title';
      }

      return 'shared_phrases.refresh_your_connection';
    }

    get subText() {
      if (this.args.completed) {
        if (this.isCreator) {
          return this.state.isConnecting ? 'credentials.header.connect_description_creator' : 'credentials.header.success_description';
        }

        return this.state.isConnecting ? 'credentials.header.connect_description' : 'credentials.header.success_description';
      } else if (this.hasUnconnectedProfessional) {
        if (this.isCreator || this.isInfluencer) {
          return 'credentials.cta.unconnected_creator';
        }

        return 'credentials.cta.unconnected';
      }

      return 'credentials.cta.expired';
    }

    *getConnectedPages() {
      try {
        yield this.facebookAuth.authenticateFacebook(this.instagramBusiness.potentialScopes);

        if (this.socialProfile.needsProfessionalTokenRefresh) {
          // business token invalidated, direct to revoke
          this.facebook.fetchPage.perform(this.auth.currentUserModel.facebookToken, this.socialProfile.facebookPageId).then(page => this.credentials.updateNameOfPage(page.name)).catch(error => this.errors.log(error, {}, 'info'));
          return yield this.args.revokePermissions.perform(this.socialProfile);
        }

        const {
          connectedPages,
          pages,
          authResponse
        } = yield this.instagramBusiness.getConnectedPages.perform(this.socialProfile);
        const facebookUser = yield this.instagramBusiness.fetchFacebookSelf();
        this.args.beginRefresh({
          connectedPages,
          pages,
          authResponse,
          facebookUser
        });
        this.segment.track('started-creds-wiz', {
          social_profile: this.socialProfile,
          pages: JSON.stringify(pages),
          page: this.credentials.source
        });
      } catch (error) {
        this.errors.log(`getConnectedPages: ${error}`);
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "credentials", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "facebook", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "facebookAuth", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "instagramBusiness", [_dec3], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "getConnectedPages", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "getConnectedPages"), _class.prototype)), _class));
  _exports.default = StatusComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, StatusComponent);
});